module.exports = __webpack_public_path__ + "static/media/animated_ashutosh1.214ad15a.png";